export const ENUM_LABELS = {
  musteri: "Müşteri",
  tedarikci: "Tedarikçi",
  diger: "Diğer",
  aktif: "Aktif",
  pasif: "Pasif",
  iptal: "İptal",
  haftalik: "Haftalık",
  aylik: "Aylık",
  uc_aylik: "3 Aylık",
  yillik: "Yıllık",
  portfoyde: "Portföyde",
  bankaya_verildi: "Bankaya Verildi",
  ciro_edildi: "Ciro Edildi",
  tahsil_edildi: "Tahsil Edildi",
  iade: "İade",
  bankada: "Bankada",
  odendi: "Ödendi",
  karsiliksiz: "Karşılıksız",
  verildi: "Verildi",
  bekliyor: "Bekliyor",
  gecikti: "Gecikti",
  nakit: "Nakit",
  havale: "Havale/EFT",
  kredi_karti: "Kredi Kartı",
  planlandi: "Planlandı",
  hesaba_gecti: "Hesaba Geçti",
  odenecek: "Ödenecek",
  kapali: "Kapalı",
  tahsil_edilecek: "Tahsil Edilecek",
  giris: "Giriş",
  cikis: "Çıkış",
  elektrik: "Elektrik",
  su: "Su",
  internet: "İnternet",
  telefon: "Telefon",
  dogalgaz: "Doğalgaz",
  odenmedi: "Ödenmedi",
  TL: "TL", USD: "USD", EUR: "EUR", GBP: "GBP",
};

export function formatMoney(v, currency = "TL") {
  if (v == null || v === "") return "—";
  const code = currency && currency !== "TL" ? currency : "TRY";
  return new Intl.NumberFormat("tr-TR", { style: "currency", currency: code }).format(v);
}

export function formatDate(v) {
  if (!v) return "—";
  try {
    return new Date(v).toLocaleDateString("tr-TR");
  } catch {
    return v;
  }
}

const CHECK_COLS = () => [
  { key: "check_no", label: "Çek No" },
  { key: "bank", label: "Banka" },
  { key: "kesideci", label: "Keşideci" },
  { key: "lehtar", label: "Lehtar (Cirolayan)" },
  { key: "company", label: "Şirket" },
  { key: "amount", label: "Tutar", type: "money" },
  { key: "due_date", label: "Vade", type: "date" },
  { key: "status", label: "Durum", type: "enum" },
];

const CHECK_FIELDS = (statuses) => [
  { key: "check_no", label: "Çek No", type: "text", required: true },
  { key: "bank", label: "Banka", type: "text", required: true },
  { key: "kesideci", label: "Keşideci", type: "text", required: true },
  { key: "lehtar", label: "Lehtar (Cirolayan)", type: "text" },
  { key: "company", label: "Şirket", type: "text" },
  { key: "amount", label: "Tutar (₺)", type: "money", required: true },
  { key: "currency", label: "Para Birimi", type: "enum", options: ["TL", "USD", "EUR", "GBP"], default: "TL" },
  { key: "due_date", label: "Vade Tarihi", type: "date", required: true },
  { key: "status", label: "Durum", type: "enum", options: statuses },
  { key: "notes", label: "Notlar", type: "textarea" },
];

export const MODULES = {
  subscriptions: {
    title: "Abonelikler",
    singular: "Abonelik",
    endpoint: "subscriptions",
    subtitle: "Tekrarlayan abonelik ve üyelik ödemeleriniz",
    stats: { pendingStatuses: ["odenmedi", "gecikti"], pendingLabel: "Bekleyen (₺)", doneStatuses: ["odendi"], doneLabel: "Ödenen (₺)", grand: "toplam" },
    searchPlaceholder: "Abonelik veya firma ara...",
    columns: [
      { key: "name", label: "Abonelik" },
      { key: "category", label: "Kategori", type: "enum" },
      { key: "counterparty", label: "Firma" },
      { key: "amount", label: "Tutar", type: "money" },
      { key: "frequency", label: "Sıklık", type: "enum" },
      { key: "son_odeme", label: "Son Ödeme", type: "date" },
      { key: "status", label: "Durum", type: "enum" },
    ],
    fields: [
      { key: "name", label: "Abonelik Adı", type: "text", required: true },
      { key: "category", label: "Kategori", type: "enum", options: ["elektrik", "su", "internet", "telefon", "dogalgaz", "diger"], default: "diger" },
      { key: "counterparty", label: "Firma / Sağlayıcı", type: "text" },
      { key: "company", label: "Şirket", type: "text" },
      { key: "amount", label: "Tutar (₺)", type: "money", required: true },
      { key: "currency", label: "Para Birimi", type: "enum", options: ["TL", "USD", "EUR", "GBP"], default: "TL" },
      { key: "frequency", label: "Sıklık", type: "enum", options: ["haftalik", "aylik", "uc_aylik", "yillik"], required: true, default: "aylik" },
      { key: "son_odeme", label: "Son Ödeme Tarihi", type: "date", required: true },
      { key: "status", label: "Durum", type: "enum", options: ["odendi", "odenmedi", "gecikti", "iptal"], default: "odenmedi" },
      { key: "notes", label: "Notlar", type: "textarea" },
    ],
  },
  checks_received: {
    title: "Alınan Çekler",
    singular: "Alınan Çek",
    endpoint: "checks_received",
    subtitle: "Müşterilerden aldığınız çekler",
    transferActions: [
      { key: "B", target: "bank", label: "Bankaya Ver" },
      { key: "C", target: "endorse", label: "Ciro Et" },
    ],
    stats: { custom: "received" },
    searchPlaceholder: "Çek no, banka veya firma ara...",
    columns: CHECK_COLS(),
    fields: CHECK_FIELDS(["portfoyde", "bankaya_verildi", "ciro_edildi", "tahsil_edildi", "iade"]),
  },
  checks_bank: {
    title: "Bankaya Verilen Çekler",
    singular: "Bankaya Verilen Çek",
    endpoint: "checks_bank",
    subtitle: "Tahsil için bankaya verdiğiniz çekler",
    revertAction: true,
    stats: { pendingStatuses: ["bankada"], pendingLabel: "Bankada (₺)", doneStatuses: ["tahsil_edildi"], doneLabel: "Tahsil Edilen (₺)", grand: "toplam" },
    searchPlaceholder: "Çek no, banka veya firma ara...",
    columns: [
      ...CHECK_COLS().slice(0, 6),
      { key: "transfer_date", label: "Veriliş Tarihi", type: "date" },
      { key: "expected_collection_date", label: "Tahmini Tahsil", type: "date" },
      ...CHECK_COLS().slice(6),
    ],
    fields: [
      ...CHECK_FIELDS(["bankada", "tahsil_edildi", "iade"]).slice(0, 7),
      { key: "transfer_date", label: "Bankaya Veriliş Tarihi", type: "date" },
      { key: "expected_collection_date", label: "Tahmini Tahsil Tarihi", type: "date" },
      ...CHECK_FIELDS(["bankada", "tahsil_edildi", "iade"]).slice(7),
    ],
  },
  checks_endorsed: {
    title: "Cirolanan Çekler",
    singular: "Cirolanan Çek",
    endpoint: "checks_endorsed",
    subtitle: "Başkasına ciro ettiğiniz çekler",
    revertAction: true,
    searchPlaceholder: "Çek no, banka veya firma ara...",
    columns: [
      ...CHECK_COLS().slice(0, 4),
      { key: "endorsed_to", label: "Kime Ciro Edildi" },
      ...CHECK_COLS().slice(4, 6),
      { key: "transfer_date", label: "Ciro Tarihi", type: "date" },
      ...CHECK_COLS().slice(6),
    ],
    fields: [
      ...CHECK_FIELDS(["ciro_edildi", "odendi", "karsiliksiz"]).slice(0, 3),
      { key: "endorsed_to", label: "Kime Ciro Edildi", type: "text" },
      ...CHECK_FIELDS(["ciro_edildi", "odendi", "karsiliksiz"]).slice(4, 7),
      { key: "transfer_date", label: "Ciro Tarihi", type: "date" },
      ...CHECK_FIELDS(["ciro_edildi", "odendi", "karsiliksiz"]).slice(7),
    ],
  },
  checks_own: {
    title: "Kendi Çeklerimiz",
    singular: "Verilen Çek",
    endpoint: "checks_own",
    subtitle: "Kendi keşide ettiğiniz çekler",
    stats: { pendingStatuses: ["verildi"], pendingLabel: "Verildi (₺)", doneStatuses: ["odendi"], doneLabel: "Ödenen (₺)", grand: "toplam" },
    searchPlaceholder: "Çek no, banka veya firma ara...",
    columns: [
      { key: "check_no", label: "Çek No" },
      { key: "bank", label: "Banka" },
      { key: "company", label: "Şirket" },
      { key: "amount", label: "Tutar", type: "money" },
      { key: "due_date", label: "Vade", type: "date" },
      { key: "status", label: "Durum", type: "enum" },
    ],
    fields: CHECK_FIELDS(["verildi", "odendi", "iade", "karsiliksiz"]).filter((f) => f.key !== "kesideci"),
  },
  dbs: {
    title: "DBS",
    singular: "DBS Kaydı",
    endpoint: "dbs",
    subtitle: "Doğrudan borçlandırma sistemi kayıtları",
    stats: { pendingStatuses: ["odenecek", "gecikti"], pendingLabel: "Ödenecek (₺)", doneStatuses: ["odendi"], doneLabel: "Ödenen (₺)", grand: "toplam" },
    searchPlaceholder: "Borçlu firma veya banka ara...",
    columns: [
      { key: "firma", label: "Firma" },
      { key: "bank", label: "Banka" },
      { key: "company", label: "Şirket" },
      { key: "amount", label: "Tutar", type: "money" },
      { key: "due_date", label: "Vade", type: "date" },
      { key: "status", label: "Durum", type: "enum" },
    ],
    fields: [
      { key: "firma", label: "Firma", type: "text", required: true },
      { key: "bank", label: "Banka", type: "text", required: true },
      { key: "company", label: "Şirket", type: "text" },
      { key: "amount", label: "Tutar (₺)", type: "money", required: true },
      { key: "currency", label: "Para Birimi", type: "enum", options: ["TL", "USD", "EUR", "GBP"], default: "TL" },
      { key: "due_date", label: "Vade Tarihi", type: "date", required: true },
      { key: "status", label: "Durum", type: "enum", options: ["odenecek", "odendi", "gecikti", "iptal"], default: "odenecek" },
      { key: "notes", label: "Notlar", type: "textarea" },
    ],
  },
  other_payments: {
    title: "Diğer Ödemeler",
    singular: "Ödeme",
    endpoint: "other_payments",
    subtitle: "Kira, elektrik, muhasebeci vb. sabit giderleriniz",
    stats: { pendingStatuses: ["odenecek"], pendingLabel: "Ödenecek (₺)", doneStatuses: ["odendi"], doneLabel: "Ödenen (₺)", grand: "toplam" },
    searchPlaceholder: "Firma veya açıklama ara...",
    columns: [
      { key: "payment_date", label: "Tarih", type: "date" },
      { key: "counterparty", label: "Firma / Alıcı" },
      { key: "company", label: "Şirket" },
      { key: "method", label: "Ödeme Şekli", type: "enum" },
      { key: "status", label: "Durum", type: "enum" },
      { key: "amount", label: "Tutar", type: "money" },
      { key: "notes", label: "Notlar" },
    ],
    fields: [
      { key: "payment_date", label: "Tarih", type: "date", required: true },
      { key: "counterparty", label: "Firma / Alıcı", type: "text", required: true },
      { key: "company", label: "Şirket", type: "text" },
      { key: "method", label: "Ödeme Şekli", type: "enum", options: ["nakit", "havale", "kredi_karti", "diger"], default: "havale" },
      { key: "status", label: "Durum", type: "enum", options: ["odenecek", "odendi"], default: "odenecek" },
      { key: "amount", label: "Tutar (₺)", type: "money", required: true },
      { key: "currency", label: "Para Birimi", type: "enum", options: ["TL", "USD", "EUR", "GBP"], default: "TL" },
      { key: "notes", label: "Notlar", type: "textarea" },
    ],
  },
  other_collections: {
    title: "Diğer Tahsilatlar",
    singular: "Tahsilat",
    endpoint: "other_collections",
    subtitle: "Kira, komisyon, hizmet vb. gelen tahsilatlarınız",
    stats: { pendingStatuses: ["tahsil_edilecek"], pendingLabel: "Tahsil Edilecek (₺)", doneStatuses: ["tahsil_edildi"], doneLabel: "Tahsil Edilen (₺)", grand: "toplam" },
    searchPlaceholder: "Firma veya açıklama ara...",
    columns: [
      { key: "collection_date", label: "Tarih", type: "date" },
      { key: "counterparty", label: "Firma / Ödeyen" },
      { key: "company", label: "Şirket" },
      { key: "method", label: "Ödeme Şekli", type: "enum" },
      { key: "status", label: "Durum", type: "enum" },
      { key: "amount", label: "Tutar", type: "money" },
      { key: "notes", label: "Notlar" },
    ],
    fields: [
      { key: "collection_date", label: "Tarih", type: "date", required: true },
      { key: "counterparty", label: "Firma / Ödeyen", type: "text", required: true },
      { key: "company", label: "Şirket", type: "text" },
      { key: "method", label: "Ödeme Şekli", type: "enum", options: ["nakit", "havale", "kredi_karti", "diger"], default: "havale" },
      { key: "status", label: "Durum", type: "enum", options: ["tahsil_edilecek", "tahsil_edildi"], default: "tahsil_edilecek" },
      { key: "amount", label: "Tutar (₺)", type: "money", required: true },
      { key: "notes", label: "Notlar", type: "textarea" },
    ],
  },
  kasa: {
    title: "Kasa",
    singular: "Kasa Hareketi",
    endpoint: "kasa",
    subtitle: "Nakit giriş/çıkış hareketleri",
    noTodayHighlight: true,
    stats: { pendingStatuses: ["giris"], pendingLabel: "Giriş (₺)", pendingCls: "text-green-600", doneStatuses: ["cikis"], doneLabel: "Çıkış (₺)", doneCls: "text-red-600", grand: "bakiye" },
    searchPlaceholder: "Açıklama ara...",
    columns: [
      { key: "txn_date", label: "Tarih", type: "date" },
      { key: "description", label: "Açıklama" },
      { key: "direction", label: "Tür", type: "enum" },
      { key: "category", label: "Kategori" },
      { key: "company", label: "Şirket" },
      { key: "amount", label: "Tutar", type: "money" },
      { key: "notes", label: "Notlar" },
    ],
    fields: [
      { key: "txn_date", label: "Tarih", type: "date", required: true },
      { key: "description", label: "Açıklama", type: "text", required: true },
      { key: "direction", label: "Tür", type: "enum", options: ["giris", "cikis"], required: true, default: "giris" },
      { key: "category", label: "Kategori", type: "text" },
      { key: "company", label: "Şirket", type: "text" },
      { key: "amount", label: "Tutar (₺)", type: "money", required: true },
      { key: "currency", label: "Para Birimi", type: "enum", options: ["TL", "USD", "EUR", "GBP"], default: "TL" },
      { key: "notes", label: "Notlar", type: "textarea" },
    ],
  },
  credit_cards: {
    title: "Kredi Kartları",
    singular: "Kredi Kartı",
    endpoint: "credit_cards",
    subtitle: "Kart limitleri, ekstre ve son ödeme takibi",
    stats: { pendingStatuses: ["odenecek"], pendingLabel: "Ödenecek Ekstre (₺)", doneStatuses: ["odendi"], doneLabel: "Ödenen Ekstre (₺)", grand: "toplam" },
    searchPlaceholder: "Kart adı veya banka ara...",
    columns: [
      { key: "bank", label: "Banka" },
      { key: "card_name", label: "Kart" },
      { key: "last4", label: "Son 4" },
      { key: "credit_limit", label: "Limit", type: "money" },
      { key: "ekstre", label: "Ekstre", type: "money" },
      { key: "kesim_tarihi", label: "Kesim Tarihi", type: "date" },
      { key: "son_odeme", label: "Son Ödeme", type: "date" },
      { key: "status", label: "Durum", type: "enum" },
      { key: "notes", label: "Notlar" },
    ],
    fields: [
      { key: "bank", label: "Banka", type: "text", required: true },
      { key: "card_name", label: "Kart Adı", type: "text", required: true },
      { key: "last4", label: "Son 4 Hane", type: "text" },
      { key: "credit_limit", label: "Kart Limiti (₺)", type: "money" },
      { key: "ekstre", label: "Ekstre Tutarı (₺)", type: "money" },
      { key: "currency", label: "Para Birimi", type: "enum", options: ["TL", "USD", "EUR", "GBP"], default: "TL" },
      { key: "kesim_tarihi", label: "Kesim Tarihi", type: "date" },
      { key: "son_odeme", label: "Son Ödeme Tarihi", type: "date" },
      { key: "status", label: "Durum", type: "enum", options: ["odenecek", "odendi", "kapali"], default: "odenecek" },
      { key: "notes", label: "Notlar", type: "textarea" },
    ],
  },
  pos_transactions: {
    title: "POS Hareketleri",
    singular: "POS Hareketi",
    endpoint: "pos_transactions",
    subtitle: "Günsonu tutar, komisyon oranı, hesabınıza geçecek net tutar",
    custom: "pos",
    noTodayHighlight: true,
    stats: { custom: "pos" },
    searchPlaceholder: "Terminal veya şirket ara...",
    columns: [
      { key: "txn_date", label: "Tarih", type: "date" },
      { key: "terminal", label: "POS Terminal" },
      { key: "company", label: "Şirket" },
      { key: "gross_amount", label: "Brüt Tutar", type: "money" },
      { key: "commission", label: "Komisyon", type: "money" },
      { key: "net_amount", label: "Net Tutar", type: "money" },
      { key: "notes", label: "Notlar" },
    ],
    fields: [
      { key: "terminal", label: "POS Terminal", type: "terminal_select", required: true },
      { key: "txn_date", label: "Tarih", type: "date", required: true },
      { key: "company", label: "Şirket (boş bırakılırsa terminalden alınır)", type: "text" },
      { key: "gross_amount", label: "Brüt Tutar (Günsonu) (₺)", type: "money", required: true },
      { key: "currency", label: "Para Birimi", type: "enum", options: ["TL", "USD", "EUR", "GBP"], default: "TL" },
      { key: "commission_rate", label: "Komisyon Oranı (%)", type: "money", default: 0 },
      { key: "notes", label: "Notlar", type: "textarea" },
    ],
  },
  credits: {
    title: "Krediler",
    singular: "Kredi",
    endpoint: "credits",
    subtitle: "Banka kredileri — vade tarihine göre Yaklaşan Ödemeler'de görünür",
    stats: { pendingStatuses: ["odenecek"], pendingLabel: "Ödenecek (₺)", doneStatuses: ["odendi"], doneLabel: "Ödenen (₺)", grand: "toplam" },
    searchPlaceholder: "Banka veya kredi türü ara...",
    columns: [
      { key: "company", label: "Şirket" },
      { key: "bank", label: "Banka" },
      { key: "credit_type", label: "Kredi Türü" },
      { key: "amount", label: "Tutar", type: "money" },
      { key: "rate", label: "Oran %" },
      { key: "due_date", label: "Vade", type: "date" },
      { key: "status", label: "Durum", type: "enum" },
      { key: "notes", label: "Notlar" },
    ],
    fields: [
      { key: "company", label: "Şirket", type: "text" },
      { key: "bank", label: "Banka", type: "text", required: true },
      { key: "credit_type", label: "Kredi Türü (örn. Rotatif, Taksitli)", type: "text" },
      { key: "amount", label: "Tutar (₺)", type: "money", required: true },
      { key: "rate", label: "Oran (%)", type: "money" },
      { key: "currency", label: "Para Birimi", type: "enum", options: ["TL", "USD", "EUR", "GBP"], default: "TL" },
      { key: "due_date", label: "Vade", type: "date", required: true },
      { key: "status", label: "Durum", type: "enum", options: ["odenecek", "odendi", "kapali"], default: "odenecek" },
      { key: "notes", label: "Notlar", type: "textarea" },
    ],
  },
};

export const TERMINAL_FIELDS = [
  { key: "name", label: "Terminal Adı", type: "text", required: true },
  { key: "bank", label: "Banka", type: "text" },
  { key: "company", label: "Şirket", type: "text" },
  { key: "commission_rate", label: "Komisyon Oranı (%)", type: "money" },
  { key: "notes", label: "Notlar", type: "textarea" },
];

export const MODULE_ORDER = [
  "subscriptions", "checks_received", "checks_bank", "checks_endorsed",
  "checks_own", "credits", "dbs", "other_payments", "other_collections", "kasa", "credit_cards", "pos_transactions",
];

export const MODULE_PATHS = {
  subscriptions: "/abonelikler",
  checks_received: "/cekler/alinan",
  checks_bank: "/cekler/bankaya-verilen",
  checks_endorsed: "/cekler/cirolanan",
  checks_own: "/cekler/kendi",
  credits: "/krediler",
  dbs: "/dbs",
  other_payments: "/odemeler",
  other_collections: "/tahsilatlar",
  kasa: "/kasa",
  credit_cards: "/kredi-kartlari",
  pos_transactions: "/pos-hareketleri",
};
